export default __webpack_public_path__ + "static/media/radio-check.5e737068.svg";